import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useLocation, Navigate } from "react-router-dom";
import Account from "../Account/Account";
import Administrator from "../Administrator/Administrator";
import NewCases from "../Cases/NewCases/Newcase";
import Dashboard from "../Dashboard/Dashboard";
import FeeAuditors from "../FeeAuditors/FeeAuditors";
import Header from "../Header/header";
import Invoices from "../Invoices/Invoices";
import Shipments from "../Shipment/Shipments";
import TiersSettings from "../LevelTiers/LevelTiers";
import TiersValue from "../FeeTiers/FeeTiers";
import Users from "../Users/Users";
import "./Layout.scss";
import LoadingOverlay from "react-loading-overlay-ts";
import { useDispatch, useSelector } from "react-redux";
import SubmitCase from "../Cases/SubmitCases/SubmitCases";
import GeneralCases from "../Cases/GeneralCases/GeneralCases";
import UserForm from "../Users/UserForm";
import AccountForm from "../Account/AccountForm";
import UploadReports from "../Reports/UploadReports";
import { Alert, Box, Button } from "@mui/material";
import Sidebar from "../SideBar/SideBar";
import AwsDialog from "../Dialogs/AwsDialog";
import { AwsParamsOne } from "../../Models/AccountAWS";
import IndexService from "../../Services/http/IndexService";
import { changeDefaultAccount } from "../Account/AccountUtil";
import AuditAnalysis from "../AuditAnalysis/AuditAnalysis";
import AwsSuccessDialog from "../Dialogs/AwsSuccessDialog";
import UpdatePaymentMethodForm from "../PaymentMethodForm/PaymentMethodForm";
import MonthlyFees from "../MonthlyFees/MonthlyFees";
import NewAccount from "../Account/NewAccount";
import RemovalShipmentDetails from "../RemovalShipmentDetails/RemovalShipmentDetails";
import DownloadReports from "../Reports/DownloadReports";
import { SessionSorageInstance } from "../../Services/SessionStorageService";
import SessionTimerService from "../../Services/SessionTimer";
import PackingListForm from "../packing_list/PackingListForm";
import PackingListForShipment from "../packing_list/PackingListForShipment";
import UrlStatusBanner from "../AmazonUrl/UrlStatusBanner";
import { AmazonURLStatus } from "../Enum/AmazonURLStatus";
import { BannerStatus } from "../../types/UrlStatusBanner.type";
import AccountsOverview from "../AccountsOverview/AccountsOverview";
import AmazonReceiptUploadFiles from "../AmazonReceipt/AmazonReceiptUploadFiles";


const Layout = () => {
  const isActive = useSelector((state: any) => state.general.isActiveSpinner);
  const dispatch = useDispatch();
  const [accountName, setAccountName] = useState(null);
  const [open, setOpen] = useState(false);
  // const [isRegister, setIsRegister] = useState(true);
  const navigate = useNavigate();
  const sessionTimeoutInMinutes = 60;
  const location = useLocation();
  const defaultAccount = useSelector((state: any) => state.account.default_account);
  const status = defaultAccount?.amazon_authorized_url_status;

  const BANNER_STATUSES = [
    AmazonURLStatus.SUBMITTED,
    AmazonURLStatus.REJECTED,
    AmazonURLStatus.APPROVED,
    AmazonURLStatus.AWAITING_COMPLETION,
  ];
  const isBannerStatus = (s: AmazonURLStatus): s is BannerStatus => BANNER_STATUSES.includes(s as BannerStatus);

  const handleTimeout = () => {
    handleLogout();
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // if (params.get("amazon_state")) {
    //   loadParamsAndRedirectAws(params);
    // }
    if (params.get("state")) {
      loginWithAws(params);
    }
    const sessionTimerService = new SessionTimerService(sessionTimeoutInMinutes);

    // Start the session timer when the component mounts
    sessionTimerService.startSessionTimer(handleTimeout);

    // Cleanup when the component unmounts
    return () => {
      sessionTimerService.stopSessionTimer();
    };
  }, []);

  // Redirect or show banner based on account Amazon URL status
  useEffect(() => {
    if (status === AmazonURLStatus.MISSING && location.pathname !== `/enterAmazonUrl/${defaultAccount.id}/`) {
      navigate(`/enterAmazonUrl/${defaultAccount.id}/`);
    }
  }, [defaultAccount]);

  // const loadParamsAndRedirectAws = (params: any) => {
  //   const amazon_callback_uri = params.get("amazon_callback_uri") || "";
  //   const amazon_state = params.get("amazon_state") || "";
  //   const selling_partner_id = params.get("selling_partner_id") || "";
  //   redirectAws(
  //     new AwsParamsOne(amazon_callback_uri, amazon_state, selling_partner_id)
  //   );
  // };
  const handleLogout = () => {
    SessionSorageInstance.clearSessionStorage();
    navigate('/');
  };

  const loginWithAws = (params: any) => {
    const spapi_oauth_code = params.get("spapi_oauth_code") || "";
    const state = params.get("state") || "";
    const selling_partner_id = params.get("selling_partner_id") || "";
    IndexService.loginWithAws(spapi_oauth_code, state, selling_partner_id, defaultAccount['id']).then(
      (response) => {
        if (response && response["message"] === "success") {
          // alert("success");
          changeDefaultAccount(dispatch, response['account']);
          setAccountName(response['account']['label']);
          // setIsRegister(true);
          // SessionSorageInstance.setUserDetails(response);
          // navigate("/layout");
        } else {
          alert("An error occurred during the AWS login Two");
        }
      });
  };

  // const redirectAws = (awsParamsOne: AwsParamsOne) => {
  //   IndexService.createAwsState(awsParamsOne).then((res) => {
  //     if (res && res["message"] === "success") {
  //       window.location.replace(res["url"]);
  //     } else {
  //       if (JSON.parse(JSON.stringify(res)).message === "account invalid") {
  //         alert("account not fount");
  //       } else {
  //         alert("An error occurred during the AWS login");
  //       }
  //     }
  //   });
  // };

  return (
    <div className="wrap">
      <LoadingOverlay className="loader" active={isActive} spinner>
        <Box sx={{ display: 'flex' }}>
          <Header open={open} />
          <Button
            variant="outlined"
            size="small"
            style={{ display: "none" }}
          ></Button>
          <Sidebar open={open} setOpen={setOpen} />
          <Box className="wrap-layout" component="main">
            {status && isBannerStatus(status) && (
              <Box sx={{ mb: 2, mx: 2 }}>
                <UrlStatusBanner status={status} onDetails={() => navigate(`/enterAmazonUrl/${defaultAccount.id}/`)}/>
              </Box>
            )}
            <AwsDialog></AwsDialog>
            <AwsSuccessDialog></AwsSuccessDialog>
            <Routes>
              <Route path="/" element={<Navigate to="accounts-overview" replace />} />
              <Route path="/accounts-overview" element={<AccountsOverview />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/:accountId" element={<Dashboard />} />
              <Route path="/shipments" element={<Shipments />} />
              <Route path="/removal-shipment-details" element={<RemovalShipmentDetails />} />
              <Route path="/feeAuditors" element={<FeeAuditors />} />
              <Route path="/new-account" element={<NewAccount />} />
              <Route path="settings/invoices" element={<Invoices />} />
              <Route path="settings/upload-reports" element={<UploadReports />} />
              <Route path="settings/download-reports" element={<DownloadReports />} />
              <Route path="settings/userDetails/:mode" element={<UserForm />} />
              <Route path="settings/payment-methods" element={<UpdatePaymentMethodForm />} />
              <Route path="settings/payment-methods/:userId" element={<UpdatePaymentMethodForm />} />
              <Route path="settings/monthly-fees" element={<MonthlyFees />} />
              <Route path="cases/general" element={<GeneralCases />} />
              <Route path="cases/new" element={<NewCases />} />
              <Route path="cases/rows" element={<SubmitCase />} />
              <Route path="/upload-amazon-receipts" element={<AmazonReceiptUploadFiles />} />
              <Route path="/administrator/accounts" element={<Account />} />
              <Route path="/administrator/users" element={<Users />} />
              <Route path="/users" element={<Users />} />
              <Route
                path="/administrator/users/details/:id/:mode"
                element={<UserForm />}
              />
              <Route
                path="/administrator/account/details/:id"
                element={<AccountForm />}
              />
              <Route
                path="/administrator/users/create/:mode"
                element={<UserForm />}
              />
              <Route path="/administrator/tiers" element={<TiersSettings />} />
              <Route path="/administrator/shipments" element={<TiersValue />} />
              <Route
                path="/administrator/viewStatus"
                element={<Administrator />}
              />
              <Route path="/audit-analysis" element={<AuditAnalysis />} />
              <Route path="/packing-list-form" element={<PackingListForm />} />
              <Route path="/packing-list-for-shipment/:shipment_id" element={<PackingListForShipment />} />

            </Routes>
          </Box>
          {/* <Footer /> */}
        </Box>
      </LoadingOverlay>
    </div>
  );
};
export default Layout;
